var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:Object.assign({}, {'pb-divider': true}, _vm.className),style:(("--divider-distance: " + _vm.distance + "rem"))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }